import { Injectable } from '@angular/core';
import { SourceDevStatus } from 'src/app/modules/platform/sources/source-modal/source-modal.component';
import { TenantSource } from '../models/tenant-source';
import { SourceListItemVM } from '../models/source-list-item';
import { isFileConnectionType } from '../utils/connection-type.util';

const SourceDevStatusDisplay = {
    [SourceDevStatus.Development]: 'Development',
    [SourceDevStatus.QAReview]: 'QA Review',
    [SourceDevStatus.Production]: 'Production',
    [SourceDevStatus.Inactive]: 'Inactive',
    [SourceDevStatus.Static]: 'Static',
    [SourceDevStatus.Deprecated]: 'Deprecated'
};

@Injectable({
    providedIn: 'root'
})
export class SourceProcessingService {
    constructor() {}

    public processSources(response: TenantSource[]): SourceListItemVM[] {
        return (
            response?.map(t => {
                return {
                    ...t,
                    disabled: false,
                    sourceIcon: isFileConnectionType(t.connectionFamily) ? 'icon-folder-tree' : 'icon-database',
                    statusDisplay: SourceDevStatusDisplay[t.status as SourceDevStatus],
                    busy: false
                } as SourceListItemVM;
            }) || []
        );
    }
}
